import store from '../store/store';
import moment from 'moment';


export function generateAPIPayload() {
    const state = (store.getState()).formData;
    console.log(state)
    var data = {};
    data.Date = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
    data.DealID = state.dealID;

    return data;
}